$(document).ready(function () {
    if ($("#grid-canvas").length > 0) {
        const canvas = document.getElementById("grid-canvas");
        const ctx = canvas.getContext("2d");
        let mouseX = 0;
        let mouseY = 0;
        let width, height;
        const gridSize = 50; // Size of grid cells
        const distortionRadius = 150; // How far from the mouse the distortion reaches
        const distortionStrength = 20; // How much the lines bend
        let animationFrameId;
        let isMouseTracking = true;

        // Set canvas to full window size
        function resizeCanvas() {
            // Get the dimensions of the .bg-grid container instead of the window
            const container = document.querySelector('.bg-grid');
            width = container.offsetWidth;
            height = container.offsetHeight;
            canvas.width = width;
            canvas.height = height;
            
            drawGrid();
        }

        // Track mouse movement throughout the entire footer
        $(document).mousemove(function (event) {
            if (!isMouseTracking) return;
            
            // Get the footer and canvas position
            const footerRect = document.querySelector('.fcfooter').getBoundingClientRect();
            const canvasRect = canvas.getBoundingClientRect();
            
            // Check if mouse is within the footer boundaries
            if (
                event.clientX >= footerRect.left && 
                event.clientX <= footerRect.right && 
                event.clientY >= footerRect.top && 
                event.clientY <= footerRect.bottom
            ) {
                // Convert to canvas coordinates
                mouseX = event.clientX - canvasRect.left;
                mouseY = event.clientY - canvasRect.top;
                
                // Cancel any existing animation frame
                if (animationFrameId) {
                    cancelAnimationFrame(animationFrameId);
                }
                
                // Request animation frame for smooth rendering
                animationFrameId = requestAnimationFrame(drawGrid);
            }
        });

        // Performance optimization: pause tracking when mouse leaves footer
        $('.fcfooter').on('mouseleave', function() {
            isMouseTracking = false;
        });
        
        $('.fcfooter').on('mouseenter', function() {
            isMouseTracking = true;
        });

        // Draw the grid with distortion
        function drawGrid() {
            ctx.clearRect(0, 0, width, height);
            ctx.strokeStyle = "#000"; // Darker color for better visibility on dark background
            ctx.lineWidth = 1;

            // Calculate grid lines
            const horizontalLines = Math.ceil(height / gridSize);
            const verticalLines = Math.ceil(width / gridSize);

            // Draw horizontal lines
            for (let i = 0; i <= horizontalLines; i++) {
                ctx.beginPath();
                for (let x = 0; x <= width; x += 5) {
                    const y = i * gridSize;
                    const distX = x - mouseX;
                    const distY = y - mouseY;
                    // Prevent division by zero
                    const distance = Math.sqrt(distX * distX + distY * distY) || 0.001;
                    
                    // Calculate distortion
                    let distortionY = 0;
                    if (distance < distortionRadius) {
                        distortionY = distortionStrength * (1 - distance / distortionRadius) * (distY / (distance || 1));
                    }
                    
                    if (x === 0) {
                        ctx.moveTo(x, y + distortionY);
                    } else {
                        ctx.lineTo(x, y + distortionY);
                    }
                }
                ctx.stroke();
            }

            // Draw vertical lines
            for (let i = 0; i <= verticalLines; i++) {
                ctx.beginPath();
                for (let y = 0; y <= height; y += 5) {
                    const x = i * gridSize;
                    const distX = x - mouseX;
                    const distY = y - mouseY;
                    // Prevent division by zero
                    const distance = Math.sqrt(distX * distX + distY * distY) || 0.001;
                    
                    // Calculate distortion
                    let distortionX = 0;
                    if (distance < distortionRadius) {
                        distortionX = distortionStrength * (1 - distance / distortionRadius) * (distX / (distance || 1));
                    }
                    
                    if (y === 0) {
                        ctx.moveTo(x + distortionX, y);
                    } else {
                        ctx.lineTo(x + distortionX, y);
                    }
                }
                ctx.stroke();
            }
        }

        // Add throttling for better performance
        function throttle(callback, delay) {
            let lastCall = 0;
            return function(...args) {
                const now = Date.now();
                if (now - lastCall >= delay) {
                    lastCall = now;
                    callback.apply(this, args);
                }
            };
        }

        // Initial setup
        $(window).resize(throttle(resizeCanvas, 100));
        
        // Initial canvas setup
        resizeCanvas();
        
        // Set a default mouse position in the center
        mouseX = width / 2;
        mouseY = height / 2;
        drawGrid();

        // For touch devices, track touch movement
        $(document).on('touchmove', function(event) {
            if (!isMouseTracking) return;
            
            const touch = event.originalEvent.touches[0] || event.originalEvent.changedTouches[0];
            const footerRect = document.querySelector('.fcfooter').getBoundingClientRect();
            const canvasRect = canvas.getBoundingClientRect();
            
            // Check if touch is within the footer boundaries
            if (
                touch.clientX >= footerRect.left && 
                touch.clientX <= footerRect.right && 
                touch.clientY >= footerRect.top && 
                touch.clientY <= footerRect.bottom
            ) {
                mouseX = touch.clientX - canvasRect.left;
                mouseY = touch.clientY - canvasRect.top;
                
                if (animationFrameId) {
                    cancelAnimationFrame(animationFrameId);
                }
                
                animationFrameId = requestAnimationFrame(drawGrid);
            }
        });
        
        // Touch enter/leave events for mobile
        $('.fcfooter').on('touchstart', function() {
            isMouseTracking = true;
        });
        
        $('.fcfooter').on('touchend', function() {
            if (!event.currentTarget.contains(event.relatedTarget)) {
                isMouseTracking = false;
            }
        });
    }
});



document.addEventListener('DOMContentLoaded', () => {
    const watermarkWrapper = document.querySelector('.watermark-wrapper');

    if (watermarkWrapper) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const svg = watermarkWrapper.querySelector('svg');
                    if (svg) {
                        const style = document.createElement('style');
                        style.textContent = `
                            @keyframes animateLetters {
                                0% {
                                    opacity: 0;
                                    transform: translateX(10px);
                                }
                                100% {
                                    opacity: 1;
                                    transform: translateX(0);
                                }
                            }
                            .watermark-wrapper svg path {
                                animation: animateLetters 1s ease-in-out forwards;
                            }
                        `;
                        document.head.appendChild(style);
                    }
                }
            });
        });

        observer.observe(watermarkWrapper);
    }
});




if ($('#dotsCanvas').length > 0) {
    document.addEventListener('DOMContentLoaded', () => {
        const canvas = document.getElementById('dotsCanvas');
        const ctx = canvas.getContext('2d');
        const container = document.querySelector('.dec-dots-active');

        if (!container) return;

        // Track mouse position
        let mouseX = -100;
        let mouseY = -100;

        // Add mouse move event listener
        canvas.addEventListener('mousemove', (e) => {
            mouseX = e.clientX;
            mouseY = e.clientY;
        });

        // Reset mouse position when mouse leaves canvas
        canvas.addEventListener('mouseleave', () => {
            mouseX = -100;
            mouseY = -100;
        });

        // Setup canvas to be full screen with proper pixel ratio
        function setupCanvas() {
            const dpr = window.devicePixelRatio || 1;
            canvas.width = window.innerWidth * dpr;
            canvas.height = window.innerHeight * dpr;
            canvas.style.width = window.innerWidth + 'px';
            canvas.style.height = window.innerHeight + 'px';
            ctx.scale(dpr, dpr);
        }

        // Handle resize
        window.addEventListener('resize', () => {
            setupCanvas();
            initDots();
        });

        // Dots configuration
        const spacing = 15;
        let dots = [];
        let maxDiagonal = 0;

        // Initialize dots positions
        function initDots() {
            dots = [];

            const cols = Math.ceil(window.innerWidth / spacing);
            const rows = Math.ceil(window.innerHeight / spacing);

            for (let row = 0; row < rows; row++) {
                for (let col = 0; col < cols; col++) {
                    dots.push({
                        x: col * spacing,
                        y: row * spacing,
                        diagonalPos: row + col
                    });
                }
            }

            maxDiagonal = (rows - 1) + (cols - 1);
        }

        // Animation parameters
        const waveDuration = 5000;
        let waveWidth = 0;

        // Animation function
        function animate() {
            if (!container.classList.contains('dec-dots-active')) {
                requestAnimationFrame(animate);
                return;
            }

            ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

            const time = (Date.now() % waveDuration) / waveDuration;
            const waveCenter = time * (maxDiagonal + waveWidth * 2) - waveWidth;

            dots.forEach(dot => {
                const distanceFromCenter = Math.abs(dot.diagonalPos - waveCenter);

                const dx = dot.x - mouseX;
                const dy = dot.y - mouseY;
                const distance = Math.sqrt(dx * dx + dy * dy);
                const hoverRadius = 100;

                let opacity = 0;
                let dotSize = 1.7;

                if (distanceFromCenter <= waveWidth) {
                    opacity = Math.pow(1 - (distanceFromCenter / waveWidth), 1.5) * 0.7;
                }

                if (distance < hoverRadius) {
                    const hoverIntensity = 1 - (distance / hoverRadius);
                    opacity = Math.min(1, opacity + (0.3 * hoverIntensity));
                    dotSize = 2.5 + (2 * hoverIntensity);
                }

                if (opacity > 0) {
                    ctx.beginPath();
                    ctx.arc(dot.x, dot.y, dotSize, 0, Math.PI * 2);
                    ctx.fillStyle = `rgba(255, 255, 255, ${opacity})`;
                    ctx.fill();
                }
            });

            requestAnimationFrame(animate);
        }

        setupCanvas();
        initDots();

        waveWidth = Math.max(maxDiagonal / 2.5, 10);

        animate();
    });
};

document.addEventListener('DOMContentLoaded', () => {
    const backToTopSvg = document.querySelector('.back-to-top a svg');

    if (backToTopSvg) {
        backToTopSvg.addEventListener('mouseenter', () => {
            
            const gTag = backToTopSvg.querySelector('g');
            if (gTag) {
                gTag.style.transition = 'transform 0.3s ease';
                gTag.style.transform = 'scale(1.01)';
            }
        });

        backToTopSvg.addEventListener('mouseleave', () => {
           
            const gTag = backToTopSvg.querySelector('g');
            if (gTag) {
                gTag.style.transition = 'transform 0.3s ease';
                gTag.style.transform = 'scale(1)';
            }
        });
    }
});


document.addEventListener('DOMContentLoaded', () => {
    const darkSection = document.querySelector('.switch-dark-mode');

    if (darkSection) {
        let isDarkModeActive = false;

        // Add smooth transition to the darkSection
        darkSection.style.transition = 'background-color 0.5s ease, color 0.5s ease';

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (!isDarkModeActive) {
                        darkSection.style.backgroundColor = 'black';
                        darkSection.style.color = 'white';
                        isDarkModeActive = true;
                    }
                } else {
                    if (isDarkModeActive && entry.boundingClientRect.top > 0) {
                        darkSection.style.backgroundColor = 'white';
                        darkSection.style.color = 'black';
                        isDarkModeActive = false;
                    }
                }
            });
        }, { threshold: 1 }); // Adjust threshold to trigger earlier

        observer.observe(darkSection);
    }
});

// homepage reveal grid 
if ($('#interactive-grid').length > 0) {
    document.addEventListener('DOMContentLoaded', function () {
        const canvas = document.getElementById('interactive-grid');
        const ctx = canvas.getContext('2d');
        let width, height;
        const gridSize = 50; // Size of grid cells

        // Set canvas to full parent size
        function resizeCanvas() {
            const container = canvas.parentElement;
            width = container.offsetWidth;
            height = container.offsetHeight;
            canvas.width = width;
            canvas.height = height;
            drawGrid();
        }

        // Draw the grid without interaction
        function drawGrid() {
            ctx.clearRect(0, 0, width, height);
            ctx.strokeStyle = "rgba(211, 211, 211, 0.4)"; // Light gray color with 0.7 opacity for grid lines
            ctx.lineWidth = 1;

            const horizontalLines = Math.ceil(height / gridSize);
            const verticalLines = Math.ceil(width / gridSize);

            // Draw horizontal lines
            for (let i = 0; i <= horizontalLines; i++) {
                ctx.beginPath();
                ctx.moveTo(0, i * gridSize);
                ctx.lineTo(width, i * gridSize);
                ctx.stroke();
            }

            // Draw vertical lines
            for (let i = 0; i <= verticalLines; i++) {
                ctx.beginPath();
                ctx.moveTo(i * gridSize, 0);
                ctx.lineTo(i * gridSize, height);
                ctx.stroke();
            }
        }

        // Resize canvas on window resize
        window.addEventListener('resize', resizeCanvas);

        // Initialize canvas size and draw grid
        resizeCanvas();
    });
};





document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('script[src*="www.cognitoforms.com"]')) {
        const url = window.location.href;
        const lastSegment = url.split('/').pop();
        console.log('Last segment of the URL:', lastSegment);
    }
});

